import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Sidebar from "./Sidebar";
import { getPopoverByName } from "../../../utils";
import { closePopover, selectSubTab } from "../../../store/common/uiSlice";

import Loader from "../Loader";
import MusicPlayer from "./MusicPlayer";
import { setProjectMusic } from "../../../store/project/projectSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import MusicMenu from "../../music/MusicMenu";

const MusicPopover = ({ type }) => {
  const dispatch = useDispatch();
  const trial = useSelector((state) => state?.user?.details?.data?.trial);
  const thisPopover = getPopoverByName("Music", trial);

  const subTab = useSelector((state) => state.ui.subTab);
  const selectedMusic = useSelector((state) => state.project.bgMusic);
  const appState = useSelector((state) => state.appState);
  const { musics } = useSelector((state) => state.media);
  const selectedTab = getPopoverByName("Music").tabs[subTab].name;
  const [openMusicMenuIndex, setOpenMusicMenuIndex] = useState();
  const isMyMusicCollection = useMemo(
    () => selectedTab === "My Music",
    [selectedTab]
  );

  const handleSlideMenu = (index) => {
    return setOpenMusicMenuIndex((prev) =>
      index !== undefined ? (prev === index ? undefined : index) : undefined
    );
  };

  const onTabSelect = useCallback(
    (tabIndex) => {
      dispatch(selectSubTab(tabIndex));
      dispatch(thisPopover.tabs[tabIndex].images());
    },
    [dispatch]
  );

  useEffect(() => {
    onTabSelect(0);
  }, []);

  const handleMediaClick = ({ id, backgroundImage, file, name, audio }) => {
    dispatch(closePopover());
    return dispatch(
      setProjectMusic({
        id,
        backgroundImage,
        file: file || audio,
        name,
        volume: 1,
      })
    );
  };

  return (
    <div
      className="flex w-full h-full"
      onClick={(e) => {
        e.stopPropagation();
        handleSlideMenu();
      }}
    >
      <Sidebar
        titleIcon={"/tool/dashboard/static/images/icons/tools/media.svg"}
        title={type}
        tabs={thisPopover.tabs}
        onTabSelect={onTabSelect}
        uploadButton={isMyMusicCollection && thisPopover.uploadButton}
      />
      <div className="p-4 w-4/5 bg-gray-100 overflow-auto h-full">
        {appState === "imageLoading" && (
          <div className="flex flex-grow h-4/5 justify-center text-sm text-gray-500 items-center text-center w-full">
            <Loader />
          </div>
        )}
        {musics.length === 0 ? (
          <div className="flex flex-grow h-4/5 justify-center text-sm text-gray-500 items-center text-center w-full">
            {" "}
            No music to show.{" "}
          </div>
        ) : (
          <div className="grid grid-cols-5 gap-4 w-full overflow-y-auto pt-4">
            {" "}
            {musics.map((music, index) => (
              <div
                key={music.id}
                className="relative overflow-visible cursor-pointer h-fit"
                onClick={(e) => {
                  e.preventDefault();
                  return handleMediaClick({ ...music });
                }}
              >
                {isMyMusicCollection && (
                  <>
                    <FontAwesomeIcon
                      icon={faEllipsisH}
                      className="cursor-pointer bg-slides-label rounded-sm w-6 h-4  absolute top-2 right-2 text-white p-1 z-50"
                      onClick={(e) => {
                        e.stopPropagation();
                        return handleSlideMenu(index);
                      }}
                    />
                    {openMusicMenuIndex === index && (
                      <div
                        className="z-50"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSlideMenu();
                        }}
                      >
                        <MusicMenu
                          handleClose={handleSlideMenu}
                          id={music.id}
                          slideIndex={index}
                          className="left-[50%] bottom-[50%] w-[188px] h-auto shadow"
                        />
                      </div>
                    )}
                  </>
                )}
                <MusicPlayer
                  isActive={selectedMusic?.id === music.id}
                  name={music.name}
                  index={index}
                  file={music.file || music.audio}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MusicPopover;
